export * from './maskEmailForDisplay'
export * from './inPlacePasswordDefer'

export async function postLogin(data: any) {
  // Perform any post-login actions
  if (data.token) {
    window.localStorage.removeItem('refCode')
    history.replaceState(
      {
        isPasswordVerified: data?.isPasswordVerified,
        passwordResetToken: data?.passwordResetToken,
      },
      '',
      ''
    )

    console.log('Login successful', data)
  }
}

export async function postLoginV2(data: any) {
  // Perform any post-login actions
  if (data.token) {
    window.localStorage.removeItem('refCode')
    history.replaceState(
      {
        isPasswordVerified: data?.isPasswordVerified,
        passwordResetToken: data?.passwordResetToken,
      },
      '',
      ''
    )

    console.log('Login successful', data)
  }
}

export function getErrorMessage(error: any): string {
  if (error?.response?.data?.message) {
    return error.response.data.message
  }
  if (error?.response?.data?.error) {
    return error.response.data.error
  }
  if (error?.message) {
    return error.message
  }
  return 'An unexpected error occurred'
}

const AUTH_ACCOUNT_BANNED = 'AUTH_ACCOUNT_BANNED'

export function isAccountBannedError(error: any): boolean {
  const status = error?.status ?? error?.response?.status
  const type = error?.data?.type ?? error?.response?.data?.type
  return status === 403 && type === AUTH_ACCOUNT_BANNED
}

export function getNetworkAwareErrorMessage(error: any): string {
  if (!navigator.onLine) {
    return 'No internet connection. Please check your network and try again.'
  }
  return getErrorMessage(error)
}

export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s]).+$/

export type ValidatePasswordT = (key: string) => string

export function validatePassword(rule: any, value: string, t: ValidatePasswordT): true | Error {
  if (!value) {
    return new Error(t('auth.validation.passwordFieldRequired'))
  }
  if (value.length < 8) {
    return new Error(t('auth.validation.passwordMinimumLength'))
  }
  if (value.trim() !== value) {
    return new Error(t('auth.validation.passwordSpacePolicy'))
  }
  if (!passwordRegex.test(value)) {
    return new Error(t('auth.validation.passwordWeak'))
  }
  return true
}

// Blocks obvious script/injection-like patterns in free-text fields (defense in depth).
// Note: backend must still validate and escape user-provided data.
export const SANITIZE_REGEX_PATTERN =
  /(<|>|&lt;|&gt;|javascript\s*:|data\s*:|vbscript\s*:|on\w+\s*=|<\s*script\b|<\/\s*script\s*>|document\.|window\.)/i

export const validateText = (value: string, t?: ValidatePasswordT): true | Error => {
  if (!value || !value.trim()) {
    return new Error(t ? t('auth.validation.textRequired') : 'This field is required')
  }
  if (value.trim().length < 2) {
    return new Error(t ? t('auth.validation.textMinLength') : 'Must be at least 2 characters')
  }
  if (SANITIZE_REGEX_PATTERN.test(value)) {
    return new Error(t ? t('auth.validation.textUnsafe') : 'Please remove special characters and try again.')
  }
  return true
}

export const textValidation = {
  validate(value: string, t?: ValidatePasswordT) {
    const result = validateText(value, t)
    return result === true ? Promise.resolve(true) : Promise.reject((result as Error).message)
  },
}

export async function validateForm(formRef: any): Promise<boolean> {
  if (!formRef || !formRef.getForm) {
    return false
  }
  try {
    await formRef.getForm().validate()
    return true
  } catch (e) {
    console.error('Form validation error:', e)
    return false
  }
}
